var React = require('react');

function PoiStar (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"id":"defs1","key":0}),React.createElement("style",{"type":"text/css","id":"style1","key":1},"\n\t.st0{fill:#333333;}\n"),React.createElement("path",{"d":"M 22.634996,42.258816 35.349932,54.649392 32.365814,72.1 48,63.861236 63.634185,72.1 60.650069,54.649392 73.365003,42.258816 55.849526,39.728801 48,23.9 40.150474,39.728801 Z","id":"path1-1","style":{"fillRule":"evenodd","stroke":"none","strokeWidth":"2.02726","fillOpacity":"1"},"key":2})]);
}

PoiStar.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 96 96","style":{"enableBackground":"new 0 0 96 96"},"fill":"#000000"};

module.exports = PoiStar;

PoiStar.default = PoiStar;
